"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOtherInput = instanceOfOtherInput;
exports.OtherInputFromJSON = OtherInputFromJSON;
exports.OtherInputFromJSONTyped = OtherInputFromJSONTyped;
exports.OtherInputToJSON = OtherInputToJSON;
/**
 * Check if a given object implements the OtherInput interface.
 */
function instanceOfOtherInput(value) {
    if (!('profession' in value) || value['profession'] === undefined)
        return false;
    if (!('professional_id' in value) || value['professional_id'] === undefined)
        return false;
    return true;
}
function OtherInputFromJSON(json) {
    return OtherInputFromJSONTyped(json, false);
}
function OtherInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'profession': json['profession'],
        'professional_id': json['professional_id'],
    };
}
function OtherInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'profession': value['profession'],
        'professional_id': value['professional_id'],
    };
}
